import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";
import ListFilters from "@/common/components/ListFilters";
import ListHeader from "@/common/components/ListHeader";
import Table from "@/common/components/Table";
import { useFilterParams } from "@/common/hooks/useFilterParams";
import { Mapper } from "@/common/services/mapper";
import { ReceiptTextIcon } from "lucide-react";
import { maintenanceWorkflowStatusOptions } from "../../constants/maintenanceWorkflowsStatus.constant";
import { maintenanceWorkflowsTableColumns } from "../../constants/maintenanceWorkflowsTableColumns.constant";
import { useMaintenanceWorkflows } from "../../hooks/useMaintenanceWorkflows";
import { MaintenanceWorkflowsTransformer } from "../../services/maintenanceWorkflowsTransformer";

const MaintenanceWorkflowsList = () => {
  const { filterParams, setFilterParams } = useFilterParams();

  const {
    data: workflows,
    meta: workflowsMeta,
    isPending: workflowsIsPending,
    refetch: refetchWorkflows,
    error: workflowsError = {} as any,
  } = useMaintenanceWorkflows({
    filters: {
      page: Number(filterParams.page) || 1,
      status: filterParams.status?.value,
    },
    mapper: Mapper.mapWithTransformer({
      transformer: MaintenanceWorkflowsTransformer.tableTransformer(),
    }),
  });

  return (
    <div className="inner-screen gap-6">
      <ListHeader
        Icon={<ReceiptTextIcon className="w-10 h-10" strokeWidth={1.5} />}
        title="Processos de manutenção"
      />

      <ErrorMessageWrapper
        className="flex-1"
        statusCode={workflowsError?.status}
        refetchFunction={refetchWorkflows}
      >
        <div className="flex-1 flex flex-col gap-6 overflow-hidden">
          <div className="flex flex-col gap-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <ListFilters
                  filters={[
                    {
                      className: '',
                      onChange: (e) => setFilterParams((prev) => ({ ...prev, status: e })),
                      value: filterParams.status,
                      options: [{ label: 'Todas', value: '' }, ...(maintenanceWorkflowStatusOptions || [])],
                      placeholder: 'Status',
                    },
                  ]}
                />
              </div>
            </div>
          </div>

          <Table
            className="flex-1 overflow-auto max-h-max"
            columns={maintenanceWorkflowsTableColumns}
            isLoadingData={workflowsIsPending}
            page={filterParams.page || 1}
            rows={workflows}
            totalPages={workflowsMeta.total_pages}
            totalCount={workflowsMeta.total}
            hasPagination
            setPage={(page) => setFilterParams((prev) => ({ ...prev, page }))}
            rowEmptyValue="--"
          />
        </div>
      </ErrorMessageWrapper>
    </div>
  );
}

export default MaintenanceWorkflowsList;
